import TextFileUpload from "../components/TextFileUpload";

const TextPage = () => {
    return <div><TextFileUpload/></div>;
};

export default TextPage;